export const videoArticlePageModule = {
  name: 'Video Article',
};
